import React, { Suspense, lazy, useState } from 'react'
import Navigation from './components/Navigation'
import SmoothScroll from './components/SmoothScroll'
import CustomCursor from './components/CustomCursor'
import Loader from './components/Loader'
import CanvasBackground from './components/CanvasBackground'
import LoadingSpinner from './components/LoadingSpinner'

// Lazy load pages for better performance
const Home = lazy(() => import('./pages/Home'))
const About = lazy(() => import('./pages/About'))
const Experience = lazy(() => import('./pages/Experience'))
const Projects = lazy(() => import('./pages/Projects'))
const Skills = lazy(() => import('./pages/Skills'))
const Contact = lazy(() => import('./pages/Contact'))

function App() {
  const [appLoaded, setAppLoaded] = useState(false);

  return (
    <SmoothScroll>
      <div className="min-h-screen bg-background/0 text-foreground font-sans overflow-x-hidden relative selection:bg-white selection:text-black cursor-none">
        
        <CanvasBackground />
        <CustomCursor />
        
        {!appLoaded && <Loader onComplete={() => setAppLoaded(true)} />}
        
        <Navigation />
        
        {/* Main Content Wrapper */}
        <main className="relative z-10 w-full overflow-hidden bg-transparent">
          <Suspense fallback={
            <div className="min-h-screen flex items-center justify-center bg-transparent">
              <div className="text-center">
                <LoadingSpinner size="large" />
                <p className="mt-4 text-muted tracking-widest text-sm uppercase">Loading Experience</p>
              </div>
            </div>
          }>
            <Home />
            <About />
            <Projects />
            <Skills />
            <Contact />
          </Suspense>
        </main>
      </div>
    </SmoothScroll>
  )
}

export default App
